import React from 'react';
import { Chip } from '@mui/material';
import {
  invoiceStatusTranslations, getInvoiceStatusColor,
  hddtStatusTranslations, getHddtStatusColor,
} from '../../utils/invoiceTranslations';

/** Status chip for internal invoice or HDDT government invoice (FINV-02-S07). */
const InvoiceStatusChip = ({ status, variant = 'internal' }) => {
  if (variant === 'hddt') {
    if (!status) return <span>--</span>;
    return (
      <Chip
        size="small"
        label={hddtStatusTranslations[status] || status}
        color={getHddtStatusColor(status)}
      />
    );
  }
  return (
    <Chip
      size="small"
      label={invoiceStatusTranslations[status] || status}
      color={getInvoiceStatusColor(status)}
    />
  );
};

export default InvoiceStatusChip;
